import { SQS } from "@aws-sdk/client-sqs";

let singletonSQSClient: SQS | null = null;

export function getSQS(): SQS {
  if (!singletonSQSClient) {
    const sqs = new SQS({
      ...(process.env.NODE_ENV === 'development' ? {
        endpoint: 'http://localhost:9324'
      } : {})
    });
    sqs.destroy = () => {console.log('Prevented singleton SQS from being destroyed');};
    singletonSQSClient = sqs;
  }
  return singletonSQSClient;
}
